import * as React from 'react';

import { History, Location } from 'history';
import { FormattedMessage } from 'react-intl';
import { Field } from 'redux-form';

import { Button } from 'components/Button';
import { Confirmation } from 'components/Confirmation';
import { Form } from 'components/Form';
import { InputOtp } from 'components/Input';
import { LayoutHeader } from 'components/Layout';
import { formatInternationalPhone } from 'helper/form';

import './OtpPage.scss';

interface OtpPageProps {
  form: string;
  history: History;
  location: Location;
  onClose: MSExecAtPriorityFunctionCallback;
  onResendOtp: (phone: string) => void;
  onSubmit: MSExecAtPriorityFunctionCallback;
  phone: string;
  validate: MSExecAtPriorityFunctionCallback;
}

interface OtpPageState {
  isConfirmationOpen: boolean;
}

export class OtpPage extends React.Component<OtpPageProps, OtpPageState> {
  private fieldOtp: Field;

  constructor(props: OtpPageProps) {
    super(props);

    this.state = {
      isConfirmationOpen: false
    };
    this.closeConfirmation = this.closeConfirmation.bind(this);
    this.handleResendOtp = this.handleResendOtp.bind(this);
    this.showConfirmation = this.showConfirmation.bind(this);
    this.setFieldOtpReference = this.setFieldOtpReference.bind(this);
  }

  componentDidMount() {
    (this.fieldOtp.getRenderedComponent() as InputOtp).focus();
  }

  componentWillUnmount() {
    const { history, location } = this.props;
    const { isConfirmationOpen } = this.state;
    if (history.action === 'POP' && !isConfirmationOpen) {
      history.push(location.pathname);
    }
  }

  render() {
    const { children, form, onClose, onSubmit, phone, validate } = this.props;
    const { isConfirmationOpen } = this.state;
    return (
      <Form
        className="o-container o-container--fluid"
        form={form}
        onSubmit={onSubmit}
        validate={validate}
      >
        <LayoutHeader actionIcon="ic-close" actionHandler={this.showConfirmation} modifier="without-border">
          <h1 className="o-layout-header-title"><FormattedMessage id="otp.page.title"/></h1>
        </LayoutHeader>
        <Confirmation
          actionNoHandler={this.closeConfirmation}
          actionNoText={<FormattedMessage id="otp.page.confirmation.no"/>}
          actionYesHandler={onClose}
          actionYesText={<FormattedMessage id="otp.page.confirmation.yes"/>}
          onOverlayClick={this.closeConfirmation}
          title={<FormattedMessage id="otp.page.confirmation.title"/>}
          isOpen={isConfirmationOpen}
        >
          <FormattedMessage id="otp.page.confirmation.info"/>
        </Confirmation>

        <p className="otp-page__info">
          <FormattedMessage id="otp.page.info"/>
        </p>
        <p className="otp-page__phone-text">{formatInternationalPhone(phone)}</p>
        <Field
          name="otp"
          className="o-form-field"
          ref={this.setFieldOtpReference}
          withRef={true}
          component={InputOtp}
        />
        {children}
        <Button type="submit" className="o-form-button button--full button--primary">
          <FormattedMessage id="otp.page.continue"/>
        </Button>
        <Button type="button" onClick={this.handleResendOtp(phone)} className="o-form-button button--full button--white">
          <FormattedMessage id="otp.page.resend"/>
        </Button>
      </Form>
    );
  }

  private handleResendOtp(phone: string) {
    const { onResendOtp } = this.props;
    return () => onResendOtp(phone);
  }

  private setFieldOtpReference(field: Field) {
    this.fieldOtp = field;
  }

  private closeConfirmation() {
    this.setState({
      isConfirmationOpen: false
    });
  }

  private showConfirmation() {
    this.setState({
      isConfirmationOpen: true
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/OtpPage/OtpPage.tsx